import React, { Component } from "react";
import MyPassengers from "../components/my-passengers/MyPassengers";

class Passengers extends Component {
	constructor() {
		super();
		this.state = {};
	}
	
	render() {
		return (
			<div className="my-passengers">
				<MyPassengers/>
			</div>
		);
	}
}

export default Passengers;
